// src/utils/task-status-utils.ts
/**
 * Utility per lo stato "Iniziato/Completato" dei task Kanban (Planner-style).
 * Tutti gli stati non-Done (Ideas/ToDo/Doing/Testing) sono presentati come "Iniziato";
 * solo StatusString === 'Done' è "Completato". I task Cancelled non compaiono in board.
 */

export const TASK_STATUS = { Started: 'Doing', Completed: 'Done' } as const;

export function isTaskCompleted(task: { isCompleted?: boolean; statusString?: string; status?: unknown }): boolean {
  if (typeof task.isCompleted === 'boolean') return task.isCompleted;
  return task.statusString === 'Done';
}

export function getTaskStatusLabel(task: { isCompleted?: boolean; statusString?: string }): string {
  return isTaskCompleted(task) ? 'Completato' : 'Iniziato';
}

export function getTaskStatusColor(task: { isCompleted?: boolean; statusString?: string }): string {
  return isTaskCompleted(task) ? 'green' : 'blue';
}
